import React from 'react';
import ReactDOM from 'react-dom';
import ShoppingCart from '../react/ShoppingCart';

export default class Application {
  constructor(params) {
    this.params = params;
    this.cartPath = params.cartPath;
    this.count = params.count;
    this.role = params.role || null;

    this.navBarSelector = params.navBarSelector || '.navbar.n2-navbar';
    this.insertBeforeSelector = params.insertBeforeSelector || `${this.navBarSelector} [data-activates="user-card-dropdown"]`;
    this._nav = $(this.navBarSelector);
    this._insertBefore = $(this.insertBeforeSelector);
  }

  load() {
    if (this.cartPath && this._insertBefore) {
      this.insertCart();
    }
  }

  insertCart() {
    const insertDiv = $('<div></div>').insertBefore(this._insertBefore);
    ReactDOM.render(<ShoppingCart href={this.cartPath} badgeCount={this.count} />, insertDiv[0]);
  }
}
